<template>
  <v-dialog v-model="show" persistent max-width="350">
    <v-card>
      <v-card-title>Create spirit</v-card-title>
      <v-divider/>
        <v-form v-model="valid" immediate ref="form">
          <v-container class="mt-4">
            <v-row>
              <v-col>
                <v-text-field label="Name" v-model="spirit.name" :rules="[fieldRules.required,fieldRules.maxLength(100)]" outlined dense :counter="100" autofocus/>
              </v-col>
            </v-row>
          </v-container>
        </v-form>
      <v-divider/>
      <v-card-actions class="pr-6">
        <v-spacer></v-spacer>
        <v-btn plain color="primary" @click="show=false;$emit('input',false)">Cancel</v-btn>
        <v-btn color="primary" @click="create()" :loading="busy">Create</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>

export default {
  name: 'SpiritQuickCreate',
	props: {
    value: {type:Boolean,required:true}
  },
  data() {
    return {
      valid: true,
      show: false,
      spirit: {name:'', vendors:[], customers:[]},
      busy: false
    }
  },
  watch: {
    value() {
      this.spirit.name = '';
      this.show = this.value;
    }
  },
  methods: {
    async create() {
      if (!this.$refs.form.validate()) {
        this.$store.commit('setError', {type:'warning',message:`One or more fields is missing or invalid`});
        return;
      }

      this.busy = true;
      const results = await this.$apiCall(`mutation SpiritQuickCreate($input: SpiritInput!) {
                                            spiritCreate(input:$input) {id,name}
                                          }`,
                                          {input:this.spirit});
      this.busy = false;
      if (!results.error) {
        this.show = false;
        this.$emit('input', false);
        this.$emit('create',results.data.spiritCreate);
      }
    }
  }
}
</script>
